import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

import { HotjarIdByUrlProps } from '@common/constants/hotjarIdByUrl';

const useHotjar = ({ hotJarIdByUrl }: { hotJarIdByUrl: HotjarIdByUrlProps }): void => {
    useEffect(() => {
        Object.entries(hotJarIdByUrl).forEach(([key, value]) => {
            if (document.baseURI.match(new RegExp(key, 'i'))) {
                hotjar.initialize(value.hjid, value.hjsv);
            }
        });
    }, [hotJarIdByUrl]);
};

export default useHotjar;
